import React from 'react';


function StandardsVersioningPolicy() {
  return (
    <>

      <div className="max-w-4xl mx-auto py-8">
        <h1 className="text-2xl font-bold text-[#102A43] mb-8 border-b border-gray-200 pb-4">Standards Versioning and Updates Policy</h1>

        <div className="text-sm text-gray-800 leading-relaxed space-y-8">
          <section>
            <p className="mb-4">
              To ensure stability while adapting to the rapid pace of technological change, the AI Accountability Standards Council adheres to a strict versioning and update policy. This framework allows for necessary evolution of standards without disrupting existing implementations.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-[#102A43] mb-3 uppercase tracking-wide">Versioning and Clarity</h2>
            <p>
              The Council utilizes a semantic versioning system (e.g., 1.0, 1.1, 2.0). All standards are versioned and dated. Older versions remain permanently accessible for historical verification. Standards are not revised outside the documented process. Major versions represent substantive changes to requirements that may necessitate operational adjustments. Minor versions represent clarifications that do not typically invalidate existing compliant workflows.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-[#102A43] mb-3 uppercase tracking-wide">When Standards Are Updated</h2>
            <p>
              Standards are not updated arbitrarily. Updates occur only when:
            </p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>New technologies fundamentally change the risk or opportunity profile of AI operations.</li>
              <li>Industry feedback identifies ambiguity in the current text.</li>
              <li>Consensus among technical advisors indicates a need to raise the baseline of performance.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-[#102A43] mb-3 uppercase tracking-wide">declaration and Version Binding</h2>
            <p>
              declaration is tied to the specific version of a standard active at the time of review (e.g., "declared against AI-ROI-1.0"). Organizations are declared against the version available at the time of their assessment. When a new version is released, existing declarations remain valid for their original term. Updates do not retroactively invalidate past declarations. Upon renewal, organizations may be required to demonstrate alignment with the most current version.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-[#102A43] mb-3 uppercase tracking-wide">Stability Over Speed</h2>
            <p>
              The Council prioritizes stability. Agencies build infrastructure around these standards; therefore, we avoid frequent, disruptive changes. We prefer fewer, more meaningful updates over constant minor revisions, allowing the ecosystem time to adapt and mature. Standards updates follow documented procedures.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-[#102A43] mb-3 uppercase tracking-wide">Archive and Accessibility</h2>
            <p>
              All previous versions of the standards are permanently archived and remain accessible. This historical record is essential for verifying declarations that were issued in the past. A declaration issued against v1.0 can always be verified against the v1.0 documentation, even if v3.0 is the current standard.
            </p>
          </section>

          <div className="pt-8 border-t border-gray-200 mt-8">
            <p className="text-xs text-gray-500">
              View current standards at the <a href="/registry" className="text-[#2F80ED] hover:underline">Official Registry</a>.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default StandardsVersioningPolicy;